// Auto-generated cornerstone translation for mt.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T15:20:52.255771+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "App tal-immaniġġjar taż-żwiemel: l-aħjar għażla għal 2026 | EquiSight",
      description: "Qabbel apps tal-immaniġġjar taż-żwiemel għal sid, staġġ u trobbija. Skopri għaliex EquiSight hija l-app kompleta għaż-żiemel tiegħek.",
      keywords: [
        "app tal-immaniġġjar taż-żwiemel",
        "app tal-immaniġġjar tal-istalla",
        "app tal-log book taż-żwiemel",
        "app biex timmaniġġja żwiemel multipli",
        "app tat-tqala tal-ferħa",
        "app tat-trobbija taż-żwiemel",
        "l-aħjar app tal-immaniġġjar taż-żwiemel",
      ],
    },
    hero: {
      eyebrow: "Gwida tal-għażla · softwer tal-immaniġġjar taż-żwiemel",
      breadcrumbLabel: "App tal-immaniġġjar taż-żwiemel",
      title: "App tal-immaniġġjar taż-żwiemel: il-gwida kompleta tal-għażla għal sidien, istalli u rziezet tat-trobbija.",
      intro: "Mhux sempliċiment lista ta' karatteristiċi — tqabbil onest, gwida tal-għażla u ħarsa lejn dak li app tal-immaniġġjar taż-żwiemel tassew trid tkun kapaċi tagħmel fl-2026. Għal żiemel wieħed, għal stalla sħiħa, jew għar-razzett tat-trobbija tiegħek.",
      pills: [
        {
          icon: "Users",
          label: "Għal sidien",
        },
        {
          icon: "Building2",
          label: "Għal istalli",
        },
        {
          icon: "Baby",
          label: "Għal rziezet tat-trobbija",
        },
        {
          icon: "Share2",
          label: "Għal timijiet",
        },
      ],
      ctas: [
        {
          label: "Ibda b'xejn b'żiemel 1",
          href: "#start",
          primary: true,
        },
        {
          label: "Għat-tabella tal-paragun",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Għaliex app tal-immaniġġjar taż-żwiemel qed issir dejjem aktar importanti.",
      lead: "L-immaniġġjar taż-żwiemel fil-prattika huwa mxerred: WhatsApp, aġenda, Excel, ritratti fuq it-telefon tiegħek, passaport tal-karta, fatturi separati u ftehimiet verbali. Anki għal żiemel wieħed, dan huwa inkommodità. Bi żwiemel multipli, rziezet tat-trobbija jew kura kondivisa, jinħolqu lakuni, appuntamenti maqbuża u tilwim.",
      items: [
        "Fejn kienet dik id-data tal-vaċċinazzjoni?",
        "Min ħallas lill-isparar taċ-ċwiefen?",
        "Liema ferħa trid tiġi kkontrollata llum?",
        "Il-kowċ qara l-istruzzjoni tal-ġimgħa l-oħra?",
        "Tassew salvajtlu dak id-dokument bil-ritratt?",
        "L-iskema tal-ikel li tinsab fl-istalla għadha korretta?",
      ],
    },
    what: {
      title: "X'inhi app tal-immaniġġjar taż-żwiemel?",
      lead: "App tal-immaniġġjar taż-żwiemel hija essenzjalment fajl diġitali għal kull żiemel. Mhux noti mxerda, iżda post wieħed għas-saħħa, it-taħriġ, l-ikel, id-dokumenti, il-ippjanar, it-tfakkir, l-ispejjeż, ir-ritratti, il-vidjows u l-aċċess kondiviz. Kulħadd madwar iż-żiemel jara l-istess informazzjoni aġġornata.",
      targetGroupsTitle: "Għal min hija maħsuba app tal-immaniġġjar taż-żwiemel?",
      targetGroups: [
        {
          icon: "Heart",
          title: "Sid privat",
          body: "Żiemel wieħed, fajl wieħed — saħħa, ippjanar u storja fil-but tiegħek.",
        },
        {
          icon: "Users",
          title: "Sid b'żwiemel multipli",
          body: "Profili separati, ippjanar separat, lista ta' kompiti kondiviza għat-tim kollu.",
        },
        {
          icon: "Building2",
          title: "Stalla tal-pensjoni u manège",
          body: "Aċċess tas-sid, istruzzjonijiet tal-kura, aġenda kondiviza u kompiti.",
        },
        {
          icon: "Baby",
          title: "Razzett tat-trobbija",
          body: "Ċiklu tal-ferħa, tqala, data tal-iżżieweġ, siġra ġenealoġika u żvilupp tal-felu.",
        },
        {
          icon: "Target",
          title: "Kowċis",
          body: "Ħarsa għal kull żiemel, irreġistrar ta' sessjonijiet, stabbiliment ta' miri, analiżi tal-vidjows.",
        },
        {
          icon: "ClipboardList",
          title: "Professjonisti",
          body: "Spaxxar taċ-ċwiefen, dentist, fisjoterapewtika jew veterinarju — jaħdmu mill-istess fajl.",
        },
      ],
    },
    criteria: {
      title: "X'għandha tissodisfa app tajba tal-immaniġġjar taż-żwiemel?",
      lead: "App mhix biss sabiħa — trid taħdem prattikament kuljum. Ħames elementi li ma jistgħux jonqsu fl-għażla tal-2026.",
      items: [
        {
          icon: "FileText",
          title: "Fajl taż-żiemel għal kull żiemel",
          body: "Dejta, età, razza, informazzjoni tal-passaport, sid, stalla, ritratti u dokumenti — kollha marbuta ma' profil wieħed taż-żiemel.",
        },
        {
          icon: "Heart",
          title: "Saħħa u kura",
          body: "Vaċċinazzjonijiet, trattament kontra d-dud, spaxxar taċ-ċwiefen, dentist, veterinarju, trattamenti, mediċina u tfakkir awtomatiku qabel id-data ta' skadenza.",
        },
        {
          icon: "Activity",
          title: "Taħriġ u progress",
          body: "Irreġistrar tat-taħriġ, noti, vidjows, riżultati tal-kompetizzjonijiet, miri u progress għal kull dixxiplina jew żiemel.",
        },
        {
          icon: "Apple",
          title: "Ikel u mmaniġġjar",
          body: "Skemi tal-ikel, supplimenti, fdal tal-ħxejjex, piż, kundizzjoni tal-ġisem u r-rutina ta' kuljum li l-istalla trid tkun taf.",
        },
        {
          icon: "Share2",
          title: "Qsim ma' oħrajn",
          body: "Aċċess għas-sid, il-kuratur, il-kowċ, is-sid tal-istalla jew professjonist — b'immaniġġjar tad-drittijiet li jixraq ir-rwol ta' kull wieħed.",
        },
        {
          icon: "Calendar",
          title: "Ippjanar u tfakkir",
          body: "Aġenda kondiviza b'kompiti, tfakkir awtomatiku u konferma sabiex xejn ma jaqa' bejn il-ħofor.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs apps oħra tal-immaniġġjar taż-żwiemel.",
      lead: "Is-SERP Olandiża hija bħalissa mimlija b'Stalmanager, LogMyHorse, EquineM u Happie Horse. Kull waħda minnhom għandha l-punti b'saħħithom tagħha. Qegħdin inqiegħdu l-funzjonijiet l-aktar mitluba wieħed biswit l-ieħor, b'mod onest u bbażat fuq informazzjoni disponibbli pubblikament.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Ibda b'xejn",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Żwiemel multipli",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Fajl tas-saħħa",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Taħriġ u progress",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ikel u supplimenti",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Ippjanar u tfakkir",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dokumenti għal kull żiemel",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Qsim mat-tim u drittijiet",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Modulu tat-trobbija (komplut)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Ċiklu tal-ferħa",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Ippjanar tat-tqala + ekografi",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Żvilupp tal-felu",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Integrazzjoni tal-professjonisti",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Għarfien EquiCoach",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Adatt għas-sid",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Adatt għat-trobbija",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Adatt għall-istalla/manège",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Tqabbil ibbażat fuq karatteristiċi disponibbli pubblikament f'Jannar 2026. Il-kompetituri huma wkoll għodod tajbin; EquiSight inbniet biex tgħaqqad il-moduli kollha f'app waħda.",
    },
    why: {
      title: "Għaliex EquiSight hija differenti.",
      lead: "Log book jirreġistra. EquiSight tgħaqqad l-immaniġġjar taż-żwiemel, it-taħriġ, l-ikel, is-saħħa, il-kompetizzjonijiet, il-professjonisti u t-trobbija f'app moderna waħda — u tmur pass aktar 'il quddiem bl-għarfien.",
      points: [
        {
          icon: "Heart",
          title: "App waħda għall-ħajja kollha taż-żiemel",
          body: "Mill-felu sat-żiemel sportiv, il-ferħa tat-trobbija jew iż-żiemel tal-irtirar. Il-fajl jikber maż-żiemel tiegħek — xejn ma jintilef fit-triq.",
        },
        {
          icon: "Sparkles",
          title: "Mhux biss dejta, iżda wkoll mudelli",
          body: "EquiCoach jgħaqqad l-iżvilupp, l-ilmenti rikorrenti, it-taħriġ u l-ikel — sabiex tara s-sinjali fi żmien, mhux avviżi separati.",
        },
        {
          icon: "Share2",
          title: "Mibni għall-kollaborazzjoni",
          body: "Is-sid, is-sid tal-istalla, il-kowċ, l-ispaxrar taċ-ċwiefen u professjonisti oħra jaħdmu mill-istess fajl taż-żiemel — bid-drittijiet li jixrqu r-rwol tagħhom.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Niċċa · trobbija",
      title: "Immaniġġjar taż-żwiemel għar-rziezet tat-trobbija.",
      lead: "Ħafna kompetituri jsemmu t-trobbija f'linja waħda. EquiSight bniett modulu komplut tat-trobbija — għax it-trobbej rari huwa l-utent finali ta' app ġenerali, iżda l-ippjanar huwa aktar meħtieġ minn kull ħadd ieħor.",
      items: [
        "Issegwi ċ-ċiklu tal-ferħa kuljum",
        "Data tal-inseminazzjoni + dejta tal-iżżieweġ",
        "Kontroll tat-tqala b'ekografi",
        "Data mistennija tal-felu + twissijiet",
        "Żvilupp tal-felu kull xahar",
        "Siġra ġenealoġika u dixxendenza",
        "Noti għal kull ferħa",
        "Ħarsa ġenerali tal-ferħiet tqal kollha",
      ],
      ctaLabel: "Ara l-modulu tat-trobbija",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Niċċa · stalla u manège",
      title: "Immaniġġjar taż-żwiemel għal żwiemel multipli u stalli tal-pensjoni.",
      lead: "Bi żwiemel multipli, il-fokus huwa inqas fuq id-dejta, u aktar fuq il-komunikazzjoni. Kull sid għandu x-xewqat tiegħu, rutini, ftehimiet tal-ikel u punti mediċi ta' attenzjoni. Kull impjegat għandu jkun jista' jaslilhom mingħajr ma jfittex.",
      cards: [
        {
          t: "Żwiemel għal kull sid",
          d: "Kull sid jara biss iż-żiemel(i) tiegħu.",
        },
        {
          t: "Istruzzjonijiet tal-kura",
          d: "Viżibbli għall-istalla għal kull żiemel.",
        },
        {
          t: "Aġenda kondiviza",
          d: "Spaxxar taċ-ċwiefen, veterinarju u kompetizzjonijiet f'ħarsa waħda.",
        },
        {
          t: "Lista tal-kompiti",
          d: "Assenjata lill-impjegati, b'konferma.",
        },
        {
          t: "Aċċess tas-sid",
          d: "Il-klijenti jaraw iż-żiemel tagħhom fl-app tagħhom stess.",
        },
        {
          t: "Kuntatti ta' emerġenza",
          d: "Dejjem jinstabu fi żmien ta' stress fl-istalla.",
        },
      ],
      ctaLabel: "Ara l-modulu tal-manège",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "Minn WhatsApp, Excel u whiteboard għal EquiSight.",
      lead: "Konkretament: hekk jinbidel l-immaniġġjar taż-żwiemel ta' kuljum tiegħek.",
      rows: [
        {
          before: "Gruppi WhatsApp",
          after: "Noti strutturati għal kull żiemel",
        },
        {
          before: "Folji Excel",
          after: "Fajl ħaj taż-żiemel b'storja",
        },
        {
          before: "Whiteboard fl-istalla",
          after: "Ippjanar kondiviz fuq it-telefon tiegħek",
        },
        {
          before: "Ritratti separati fuq il-kamera",
          after: "Midja marbuta maż-żiemel tiegħek",
        },
        {
          before: "Ftehimiet verbali",
          after: "Kompiti u tfakkir b'konferma",
        },
        {
          before: "Passaport tal-karta mitlef",
          after: "Dokumenti dejjem f'idejk",
        },
      ],
    },
    helper: {
      title: "Liema app tal-immaniġġjar taż-żwiemel tixraqlek?",
      lead: "Wieġeb dawn il-5 mistoqsijiet u tirċievi rakkomandazzjoni onesta — anki jekk din mhix dejjem EquiSight.",
      questions: [
        {
          id: "horses",
          q: "Għandek żiemel wieħed jew żwiemel multipli?",
          options: [
            {
              label: "Żiemel wieħed",
              score: 1,
            },
            {
              label: "2–5 żwiemel",
              score: 2,
            },
            {
              label: "Aktar minn 5 żwiemel",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "Timmaniġġja żwiemel tal-klijenti jew ta' terzi?",
          options: [
            {
              label: "Le, biss iż-żwiemel tiegħi stess",
              score: 0,
            },
            {
              label: "Kultant — għall-familja jew ħbieb",
              score: 1,
            },
            {
              label: "Iva, professjonalment (stalla / manège)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "Trid issegwi t-trobbija u t-tqala?",
          options: [
            {
              label: "Mhux rilevanti",
              score: 0,
            },
            {
              label: "Kultant — trobbija okkażjonali",
              score: 1,
            },
            {
              label: "Iva, jien (jew ser inkun) trobbej",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "Taħdem flimkien ma' kowċ, kuratur jew professjonist?",
          options: [
            {
              label: "Le, nagħmel kollox jiena",
              score: 0,
            },
            {
              label: "Iva, ma' persuna waħda",
              score: 1,
            },
            {
              label: "Iva, ma' persuni multipli",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Trid biss tirreġistra jew ukoll tikseb għarfien?",
          options: [
            {
              label: "Biss irreġistrar",
              score: 1,
            },
            {
              label: "Irreġistrar + ippjanar",
              score: 2,
            },
            {
              label: "Irreġistrar + ippjanar + għarfien",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Log book sempliċi huwa biżżejjed — u jikber miegħek.",
          body: "Għal żiemel wieħed mingħajr kura kondiviza, kull app tal-immaniġġjar taż-żwiemel hija adatta. EquiSight tibda b'xejn b'żiemel 1, għalhekk m'hemm l-ebda riskju. Jekk aktar tard trid iżżid iżjed żwiemel, kowċ jew trobbija, kollox huwa diġà fih.",
          cta: "Ibda b'xejn b'żiemel 1",
        },
        mid: {
          title: "EquiSight tixraq tajjeb għas-sitwazzjoni tiegħek.",
          body: "Għandek bżonnijiet multipli (żwiemel multipli, kollaborazzjoni jew għarfien). Il-biċċa l-kbira tal-kompetituri jkopru 1-2 moduli; EquiSight tgħaqqadhom f'app waħda, mingħajr ma tgħaqqad għodod separati.",
          cta: "Ara x'tista' tagħmel EquiSight",
        },
        high: {
          title: "EquiSight hija l-għażla l-aktar loġika.",
          body: "Is-sitwazzjoni tiegħek tgħaqqad żwiemel multipli, kollaborazzjoni, trobbija u/jew għarfien. Dan huwa eżattament fejn EquiSight tagħmel id-differenza — mhux għodod mxerda, iżda fajl wieħed taż-żiemel għal kulħadd u kollox madwar iż-żiemel.",
          cta: "Ibda b'xejn ma' EquiSight",
        },
      },
    },
    faqTitle: "Mistoqsijiet frekwenti dwar apps tal-immaniġġjar taż-żwiemel",
    faq: [
      {
        q: "X'inhi l-aħjar app tal-immaniġġjar taż-żwiemel?",
        a: "L-aħjar app tal-immaniġġjar taż-żwiemel tiddependi fuq is-sitwazzjoni tiegħek. Għal sempliċement log book, ħafna apps huma adatti. Jekk trid tgħaqqad saħħa, taħriġ, ikel, dokumenti, trobbija, ippjanar u kollaborazzjoni, EquiSight inbniet bħala soluzzjoni kompleta fejn kollox jiġi flimkien f'fajl wieħed.",
      },
      {
        q: "Nista' nimmaniġġja żwiemel multipli f'app waħda?",
        a: "Iva. App tajba tal-immaniġġjar taż-żwiemel trid tappoġġja żwiemel multipli, inklużi sidien, kuratura, rutini, dokumenti, appuntamenti u tfakkir għal kull żiemel. EquiSight ġiet iddisinjata għal dan mill-ewwel linja tal-kodiċi — iż-żwiemel huma fajls individwali, mhux ringieli f'lista.",
      },
      {
        q: "EquiSight hija adatta wkoll għar-rziezet tat-trobbija?",
        a: "Iva. EquiSight tista' tiġi kkonfigurata b'funzjonijiet tat-trobbija bħaċ-ċiklu tal-ferħa, id-data tal-inseminazzjoni, il-kontroll tat-tqala, id-dejta tal-iżżieweġ, is-siġra ġenealoġika, id-data mistennija tal-felu u l-iżvilupp tal-felu. Dan huwa eżattament il-qasam fejn il-biċċa l-kbira tal-apps kompetituri ma jirrispondux jew jirrispondux ftit.",
      },
      {
        q: "Nista' naqsam id-dejta mal-kowċ jew l-ispaxrar taċ-ċwiefen tiegħi?",
        a: "Iva. L-għan ta' EquiSight huwa li l-informazzjoni rilevanti tkun tista' tinqasam b'mod sikur mal-persuni madwar iż-żiemel — kowċ, spaxrar taċ-ċwiefen, dentist, veterinarju, fisjoterapewtika, kuratur jew sid. Kull persuna tirċievi biss id-drittijiet meħtieġa għar-rwol tagħha.",
      },
      {
        q: "Għaliex ma tużax sempliċement WhatsApp jew Excel?",
        a: "WhatsApp u Excel jaħdmu sakemm il-affarijiet jibqgħu sempliċi. Hekk kif ikollok żwiemel multipli, appuntamenti, dokumenti, trattamenti, sidien jew dejta tat-trobbija, isiru suxxettibbli għal żbalji: l-informazzjoni tinxtered, it-tfittxija tieħu ħin u l-ftehimiet verbali jintesew. App tal-immaniġġjar taż-żwiemel tgħaqqad kollox flimkien għal kull żiemel, b'tfakkir awtomatiku.",
      },
      {
        q: "Kemm tiswa EquiSight?",
        a: "Tista' tibda b'xejn b'żiemel 1. Jekk trid timmaniġġja żwiemel multipli, tattiva t-trobbija jew tagħti aċċess lill-professjonisti, jeżistu pjanijiet Premium bi prezz raġonevoli. Ara l-għażliet attwali fuq il-paġna tal-prezzijiet.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "Software tal-trobbija taż-żwiemel: paragun sħiħ 2026",
      description: "Qabbel is-software tal-trobbija taż-żwiemel: ċiklu tal-ħtieqa, tqala, għażla tal-istalun u ftieli. Skopri għaliex EquiSight hija l-app sħiħa tat-trobbija.",
      keywords: [
        "software trobbija żwiemel",
        "app ċiklu tal-ħtieqa",
        "app tqala tal-ħtieqa",
        "app reġistrazzjoni felu",
        "app ktieb tar-razza żiemel",
        "ippjanar tgħammir żiemel",
        "app għażla stallun",
      ],
    },
    hero: {
      eyebrow: "Għajnuna fl-għażla · software tat-trobbija",
      breadcrumbLabel: "Software tat-trobbija",
      title: "Software tat-trobbija taż-żwiemel: il-paragun sħiħ għall-2026.",
      intro: "Ħtieqa tat-trobbija tistħoqqilha aktar minn app ġenerali ta' ġestjoni taż-żwiemel. Qabbel il-funzjonijiet tat-trobbija tal-għodod l-aktar magħrufa, skopri dak li verament importanti, u agħżel b'għaqal is-software li taqbel mal-imsella tiegħek — kbira jew żgħira.",
      pills: [
        {
          icon: "Baby",
          label: "Ċiklu tal-ħtieqa",
        },
        {
          icon: "Heart",
          label: "Kontroll tat-tqala",
        },
        {
          icon: "Sparkles",
          label: "Żvilupp tal-felu",
        },
        {
          icon: "FileText",
          label: "Ktieb tar-razza",
        },
      ],
      ctas: [
        {
          label: "Ibda b'xejn bil-modulu tat-trobbija",
          href: "#start",
          primary: true,
        },
        {
          label: "Għall-tabella tal-paragun",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Għaliex app ordinarja ta' ġestjoni taż-żwiemel mhijiex biżżejjed għat-trobbija.",
      lead: "Il-biċċa l-kbira tal-apps ekwestri huma ddisinjati għal żiemel sportiv jew rikreattiv wieħed. It-trobbija għandha ritmu kompletament differenti: ħtieqa, inseminazzjoni, kontroll tat-tqala, eċos, kalendarju tal-ftieli, siġra ġenealoġika u bejgħ. Excel wieħed jinħasar wara 2 staġuni — u meta jkollok aktar minn ħtieqa waħda titlef il-kontroll.",
      items: [
        "Meta kien l-aħħar ċiklu ta' Bonita eżattament?",
        "Liema stallun huwa ppjanat għat-tgħammir l-istaġun li ġej?",
        "L-eċo tal-21 jum ġie skedat diġà?",
        "Liema ftieli tal-2024 inbiegħu diġà?",
        "Fejn tinsab is-siġra ġenealoġika sal-nonnu min-naħa tal-omm?",
        "Fejn huma l-kampjuni tad-DNA u d-dettalji tal-passaport?",
      ],
    },
    what: {
      title: "X'inhi s-software tat-trobbija taż-żwiemel?",
      lead: "Is-software tat-trobbija hija fajl speċjalizzat għal kull ħtieqa u stallun, ikkombinata ma' kalendarju tas-sena tat-trobbija, ippjanar tat-tqala, reġistrazzjoni tal-ftieli u preżentazzjoni tas-siġra ġenealoġika. Mhux ġurnal ġenerali taż-żwiemel, iżda għodda li tifhem iċ-ċiklu tat-trobbija: mill-ewwel ħtieqa sal-fewtir.",
      targetGroupsTitle: "Għal liema tip ta' trobbej hija s-software tat-trobbija?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Trobbej tal-passattemp (1-3 ħtieqiet)",
          body: "Tgħammira jew tnejn fis-sena — ħarsa ġenerali mingħajr akrobatika bl-Excel.",
        },
        {
          icon: "Building2",
          title: "Imsella żgħira (4-10 ħtieqiet)",
          body: "Pjan tas-sena tat-trobbija biċ-ċiklu, inseminazzjoni, kontrolli tat-tqala u fajl tal-felu.",
        },
        {
          icon: "Users",
          title: "Imsella professjonali (10+)",
          body: "Ħaddiema multipli, għażla tal-istalun għal kull ħtieqa, bejgħ u marketing.",
        },
        {
          icon: "Target",
          title: "Sid l-istalun",
          body: "Storja tal-ordnijiet, statistiċi tas-semen u aġenda għal kull stalun.",
        },
        {
          icon: "Heart",
          title: "Trapjant tal-embriju",
          body: "Donatrici + ħtieqa riċevitura bħala fajl marbut, kalendarju ET.",
        },
        {
          icon: "ClipboardList",
          title: "Reġistrazzjoni fil-ktieb tar-razza",
          body: "Kampjuni tad-DNA, dokumenti tal-passaport u data tas-siġra ġenealoġika.",
        },
      ],
    },
    criteria: {
      title: "X'għandha tissodisfa s-software tajba tat-trobbija?",
      lead: "Mhux kull 'funzjoni tat-trobbija' f'app taż-żwiemel hija l-istess. Ħames oqsma ewlenin fejn it-trobbejja jitilfu ħafna ħin — u fejn is-software tħalli differenza reali.",
      items: [
        {
          icon: "Calendar",
          title: "Ċiklu tal-ħtieqa u ħtieqa",
          body: "Reġistru ta' kuljum, ovulazzjoni predittiva, progress għal kull ċiklu u tfakkir awtomatiku.",
        },
        {
          icon: "Heart",
          title: "Inseminazzjoni u kontroll tat-tqala",
          body: "Dati tat-tgħammir u inseminazzjoni, dettalji tal-istalun, eċo tal-14 jum, tal-21 jum, tas-60 jum u determinazzjoni tas-sess.",
        },
        {
          icon: "Baby",
          title: "Żvilupp tal-felu",
          body: "Data tat-twelid, grafiku tal-piż, skeda ta' trattament kontra d-dud, mument tal-fewtir, reġistrazzjoni tal-passaport.",
        },
        {
          icon: "FileText",
          title: "Siġra ġenealoġika u dokumenti",
          body: "Preżentazzjoni tas-siġra ġenealoġika sa 4-5 ġenerazzjonijiet, DNA, numri tal-passaport u status fil-ktieb tar-razza.",
        },
        {
          icon: "Target",
          title: "Għażla u abbinament tal-istalun",
          body: "Filtrar skont id-dixxiplina, linji, dettalji tal-istalun u suċċess storiku — mhux biss dak li jippromwovi l-proprjetarju tal-istalun.",
        },
        {
          icon: "Share2",
          title: "Kollaborazzjoni mat-tabib veterinarju/inseminatur",
          body: "Eċos, kampjuni u stati kondivisi direttament mal-prattika li taħdem fuq il-ħtieqiet tiegħek.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs software oħra tat-trobbija.",
      lead: "Is-SERP Olandiż għas-software tat-trobbija spiss juri apps ġeneriċi taż-żwiemel li jsemmu t-trobbija f'sentenza waħda. Niqabblu b'mod ġust liema għodod għandhom verament fluss sħiħ tat-trobbija.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Ibda b'xejn",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Irreġistra ċ-ċiklu tal-ħtieqa",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Data tal-inseminazzjoni + stalun",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Eċos u kontroll tat-tqala",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Data mistennija tal-felu",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Fajl tal-felu (piż/tkabbir)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Siġra ġenealoġika sa 4-5 ġenerazzjonijiet",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Reġistrazzjoni tad-DNA u passaport",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Għażla / abbinament tal-istalun",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "ET / trapjant tal-embriju",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Ħarsa ġenerali ta' ħtieqiet multipli",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Mobbli (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Qsim mat-tabib veterinarju",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrat mal-fajl ġenerali",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Bejgħ u marketing tal-ftieli",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Paragun ibbażat fuq karatteristiċi disponibbli pubblikament f'Jannar 2026. EquineGenie huwa b'saħħtu fit-trobbija, iżda inqas fil-mobbiltà + ġestjoni ġenerali taż-żwiemel. EquiSight jikkombina t-tnejn.",
    },
    why: {
      title: "Għaliex EquiSight jaqdi t-trobbejja b'mod differenti.",
      lead: "Ħafna trobbejja jaħdmu b'software separata tat-trobbija u app separata ta' ġestjoni taż-żwiemel. EquiSight jikkombina t-tnejn — mingħajr ma taqbad tibdel bejn apps jew ddaħħal data doppja.",
      points: [
        {
          icon: "Heart",
          title: "Il-ħtieqa tat-trobbija tibqa' wkoll żiemel normali",
          body: "Il-ħtieqa tat-trobbija għandha sena trobbija u fajl normali ta' żiemel — saħħa, vaċċini, farrier. App waħda, il-moduli kollha.",
        },
        {
          icon: "Sparkles",
          title: "Predittiv mhux reattiv",
          body: "Tbassir taċ-ċiklu, tfakkir ta' oqsma ewlenin tat-tqala u kalendarju tal-ftieli — awtomatikament ibbażat fuq id-data tiegħek.",
        },
        {
          icon: "Share2",
          title: "Kulħadd madwar it-trobbija",
          body: "Inseminatur, sid l-istalun, tabib veterinarju, xerrej, ktieb tar-razza — ilkoll b'aċċess bid-drittijiet it-tajba.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Għal kull dixxiplina · miċ-ċiklu sal-fewtir",
      title: "X'fih fajl tat-trobbija f'EquiSight.",
      lead: "Għal kull ħtieqa tikseb fajl sħiħ tat-trobbija, marbut mal-fajl normali tagħha bħala żiemel.",
      items: [
        "Reġistru ta' kuljum taċ-ċiklu b'tbassir",
        "Inseminazzjoni/tgħammir + dettalji tal-istalun",
        "Linja tal-ħin tal-eċos (14/21/60 jum + sess)",
        "Oqsma ewlenin tat-tqala b'tfakkir awtomatiku",
        "Data mistennija tal-felu u preparazzjoni",
        "Fajl tal-felu mill-ġurnata tat-twelid",
        "Siġra ġenealoġika sal-nanniet b'navigazzjoni bil-klikk",
        "Kampjun tad-DNA, passaport, status fil-ktieb tar-razza",
        "Pipeline tal-bejgħ b'lista tal-interessati",
        "Storja tal-għażla tal-istalun għal kull ħtieqa",
      ],
      ctaLabel: "Ara l-modulu tat-trobbija",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Għall-imsella kollha",
      title: "Ħarsa ġenerali fuq ħtieqiet u staljuni multipli.",
      lead: "Meta trobbi aktar minn 2-3 ħtieqiet, il-ħarsa ġenerali fuq iċ-ċikli u t-tqaliet kollha ssir kruċjali.",
      cards: [
        {
          t: "Dashboard taċ-ċiklu",
          d: "Il-ħtieqiet kollha maġenb xulxin, bil-fażi taċ-ċiklu u l-azzjoni li jmiss.",
        },
        {
          t: "Pipeline tat-tqala",
          d: "Liema ħtieqiet fejn huma fl-oqsma ewlenin tat-tqala?",
        },
        {
          t: "Kalendarju tal-ftieli",
          d: "Twelid mistenni kull xahar, bil-loġistika koordinata.",
        },
        {
          t: "Portafoll tal-istalun",
          d: "Staljuni proprji jew inseminaturi fissi b'storja tal-ordnijiet.",
        },
        {
          t: "Grafiku tas-siġra ġenealoġika",
          d: "Analiżi tal-antenati fuq diversi ġenerazzjonijiet u linji.",
        },
        {
          t: "Dashboard tal-bejgħ",
          d: "Liema ftieli nbiegħu, ġew irreservati jew għadhom disponibbli.",
        },
      ],
    },
    beforeAfter: {
      title: "Mill-Excel u l-aġenda għal EquiSight tat-trobbija.",
      lead: "Konkretu: hekk tinbidel l-istaġun tat-trobbija tiegħek.",
      rows: [
        {
          before: "Ċiklu f'nota separata",
          after: "Reġistru ta' kuljum b'tbassir",
        },
        {
          before: "Eċos bil-WhatsApp lill-inseminatur",
          after: "Fajl kondiviż b'ritratti",
        },
        {
          before: "Data tat-tqala fl-aġenda",
          after: "Tfakkir awtomatiku tal-oqsma ewlenin",
        },
        {
          before: "Passaport tal-felu fid-dielja",
          after: "Dokument marbut mal-profil tal-felu",
        },
        {
          before: "Siġra ġenealoġika fuq karta",
          after: "Siġra ġenealoġika li tinnaviga bil-klikk sa 4-5 ġenerazzjonijiet",
        },
        {
          before: "Reklam tal-bejgħ fuq Marktplaats",
          after: "Pipeline tal-bejgħ b'lista tal-interessati",
        },
      ],
    },
    helper: {
      title: "Liema software tat-trobbija taqbel miegħek?",
      lead: "5 mistoqsijiet biex tara jekk għandekx bżonn app sħiħa tat-trobbija jew jekk għodda tal-passattemp hija biżżejjed.",
      questions: [
        {
          id: "mares",
          q: "Kemm ħtieqiet tat-trobbija timmaniġġja?",
          options: [
            {
              label: "Ħtieqa waħda",
              score: 1,
            },
            {
              label: "2-5 ħtieqiet",
              score: 2,
            },
            {
              label: "Aktar minn 5 ħtieqiet",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "Kemm drabi trobbi fis-sena?",
          options: [
            {
              label: "Inċidentalment (kull ftit snin)",
              score: 0,
            },
            {
              label: "Kull sena 1-2 tgħammiriet",
              score: 2,
            },
            {
              label: "Kull sena 3+ tgħammiriet",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "Kif tinsemina/tgħammer?",
          options: [
            {
              label: "Tgħammir naturali",
              score: 1,
            },
            {
              label: "AI frisk/semen imkessaħ",
              score: 2,
            },
            {
              label: "ET jew iffriżar fil-fond",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "Taħdem flimkien mat-tabib veterinarju/inseminatur?",
          options: [
            {
              label: "Persuna fissa waħda",
              score: 1,
            },
            {
              label: "Prattiki multipli",
              score: 2,
            },
            {
              label: "Netwerk internazzjonali",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "X'qiegħed issegwi bħalissa?",
          options: [
            {
              label: "Excel jew karta",
              score: 1,
            },
            {
              label: "App ġenerali ta' ġestjoni taż-żwiemel",
              score: 2,
            },
            {
              label: "Xejn strutturat",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Għodda tal-passattemp jew Excel hija biżżejjed — iżda EquiSight jibqa' utli.",
          body: "Għal ħtieqa waħda b'tgħammir naturali kull ftit snin, modulu estensiv tat-trobbija huwa żejjed. EquiSight jibda b'xejn u tattiva l-modulu tat-trobbija biss għas-sena li fiha ttgħammer — mingħajr obbligu ta' aġġornament.",
          cta: "Ibda b'xejn",
        },
        mid: {
          title: "EquiSight tat-trobbija hija l-għodda t-tajba.",
          body: "Għandek ħtieqiet multipli jew metodi multipli ta' trobbija — apps ġenerali taż-żwiemel mhumiex mibnijiex għal dan. EquiSight jikkombina t-trobbija + il-kura ġenerali, sabiex ma tkollix għalfejn tibdel bejn żewġ għodod.",
          cta: "Ara l-modulu tat-trobbija",
        },
        high: {
          title: "EquiSight huwa mibni għall-imsella tiegħek.",
          body: "Ħtieqiet multipli, ET jew iffriżar fil-fond, tim internazzjonali — il-biċċa l-kbira tal-għodod jaqgħu qasir hawn. EquiSight jiskala sal-livell tal-imsella mingħajr ma tiżżarrad liċenzji addizzjonali.",
          cta: "Ikkuntattjana dwar pjan tal-imsella",
        },
      },
    },
    faqTitle: "Mistoqsijiet frekwenti dwar is-software tat-trobbija",
    faq: [
      {
        q: "X'inhi l-aħjar software tat-trobbija taż-żwiemel?",
        a: "Għal ħtieqa waħda mingħajr metodu kumplikat ta' trobbija, ħafna għodod huma biżżejjed. Mill-2-3 ħtieqiet 'il quddiem, bl-użu tal-AI jew ET, jew bil-kollaborazzjoni mat-tabib veterinarju u l-ktieb tar-razza, modulu sħiħ tat-trobbija jsir kruċjali. EquiSight jikkombina t-trobbija mal-ġestjoni ġenerali taż-żwiemel f'app waħda, sabiex ma jkollokx għalfejn tibdel.",
      },
      {
        q: "Liema funzjonijiet tat-trobbija verament neħtieġ?",
        a: "Minimu: reġistru taċ-ċiklu, data tat-tgħammir/inseminazzjoni, oqsma ewlenin tal-kontroll tat-tqala, u fajl tal-felu. Opzjonali iżda b'saħħtu: preżentazzjoni tas-siġra ġenealoġika, arkivju tal-għażla tal-istalun, DNA/passaport u pipeline tal-bejgħ.",
      },
      {
        q: "Jista' EquiSight jibbassar iċ-ċiklu ta' ħtieqa?",
        a: "Iva. EquiSight juża data ta' ċikli preċedenti biex juri l-ovulazzjoni mbassra, sabiex tippjana l-inseminazzjoni jew it-tgħammir fil-mument it-tajjeb — mingħajr ma tħabbat rasek kuljum.",
      },
      {
        q: "Jaħdem EquiSight ukoll għat-trapjant tal-embriju?",
        a: "Iva. Il-ħtieqa donatrici u dik riċevitura jiksbu fajls marbuta, kalendarju ET u oqsma ewlenin kondiviżi mal-prattika. B'hekk ma titlefx l-linja tal-ħin fil-fluss kumpless tal-ET.",
      },
      {
        q: "Nista' nimporta d-data tal-trobbija eżistenti tiegħi?",
        a: "Tista' ddaħħal data taċ-ċiklu, tat-tgħammiriet u tal-ftieli manwalment jew f'lott permezz ta' CSV. Għal operazzjonijiet ta' trobbija attivi ngħinuk b'migrazzjoni ta' darba jekk għandek data fuq diversi staġuni.",
      },
      {
        q: "Kif nikkondividi l-fajl mat-tabib veterinarju jew inseminatur tiegħi?",
        a: "Kull persuna tikseb aċċess b'rwol: tabib veterinarju, inseminatur, sid l-istalun jew uffiċjal tal-ktieb tar-razza. Kulħadd jara biss l-informazzjoni meħtieġa għar-rwol tiegħu — ma hemm bżonn ta' aċċess sħiħ.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Software għall-manège: paragun komplut u gwida għall-għażla 2026",
      description: "Qabbel software għall-manège għal lezzjonijiet, kavalieri, żwiemel u amministrazzjoni. Skopri liema app taqbel mal-manège jew l-istalla tal-pensjoni tiegħek.",
      keywords: [
        "software għall-manège",
        "app ġestjoni tal-istalla",
        "software amministrazzjoni manège",
        "ppjanar lezzjonijiet manège",
        "software istalla pensjoni",
        "amministrazzjoni kavalieri",
        "amministrazzjoni żwiemel manège",
      ],
    },
    hero: {
      eyebrow: "Gwida għall-għażla · software manège",
      breadcrumbLabel: "Software manège",
      title: "Software għall-manège: il-gwida kompluta għall-għażla għal maneġġi u stalli tal-pensjoni.",
      intro: "Ppjanar lezzjonijiet, amministrazzjoni kavalieri, ġestjoni żwiemel, fatturazzjoni u komunikazzjoni — software tajjeb għall-manège iġib kollox flimkien. Qabbel l-aktar għażliet magħrufa u skopri liema wieħed jaqbel mal-istalla jew il-manège tiegħek.",
      pills: [
        {
          icon: "Calendar",
          label: "Ppjanar lezzjonijiet",
        },
        {
          icon: "Users",
          label: "Kavalieri & klijenti",
        },
        {
          icon: "Heart",
          label: "Kura tal-żwiemel",
        },
        {
          icon: "CreditCard",
          label: "Fatturazzjoni",
        },
      ],
      ctas: [
        {
          label: "Itlob demo",
          href: "#start",
          primary: true,
        },
        {
          label: "Għal tabella ta' paragun",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Għaliex għodod imxerrda jnaqqsu l-pass tal-manège.",
      lead: "Il-biċċa l-kbira tal-maneġġi jaħdmu bi patchwork: ppjanar lezzjonijiet fuq whiteboard, reġistrazzjoni kavalieri f'Excel, fatturazzjoni f'għodda oħra, kura żwiemel fuq WhatsApp u kuntatt mas-sidien permezz ta' messaġġi personali. F'ġimgħa moħħija jinħolqu bookings doppji, fatturi minsija jew żwiemel li ma jafux liema kavalier se jirċevuhom.",
      items: [
        "Min qiegħed fil-lezzjoni ta' Jasmijn bħalissa?",
        "Liema kavalier għadu ma ħallasx għal Marzu?",
        "Liema żiemel ma jistax jintuża din il-ġimgħa?",
        "Min huma l-kuntatti ta' emerġenza tal-istudenti?",
        "Is-sid ta' Stardust irċieva l-fattura tal-ħaddied?",
        "Liema żiemel qiegħed f'liema box?",
      ],
    },
    what: {
      title: "X'inhu software għall-manège?",
      lead: "Software għall-manège jgħaqqad ppjanar lezzjonijiet, amministrazzjoni kavalieri, ġestjoni żwiemel, fatturazzjoni u komunikazzjoni f'għodda waħda. L-ebda akrobazija Excel jew spaghetti WhatsApp, iżda post wieħed fejn il-manège taħdem u s-sidien/kavalieri jistgħu jsegwu.",
      targetGroupsTitle: "Għal liema tip ta' negozju huwa maħsub software tal-manège?",
      targetGroups: [
        {
          icon: "Building2",
          title: "Manège żgħira (1-15 żiemel)",
          body: "L-aktar ppjanar lezzjonijiet u ħlasijiet — amministrazzjoni mingħajr uġigħ ta' ras.",
        },
        {
          icon: "Users",
          title: "Manège ta' daqs medju (15-40 żiemel)",
          body: "Diversi istruttori, ppjanar lezzjonijiet + ġestjoni żwiemel + amministrazzjoni kavalieri.",
        },
        {
          icon: "ClipboardList",
          title: "Istalla kbira ta' rikkieb u pensjoni (40+)",
          body: "Operazzjoni sħiħa inkluż fatturazzjoni, ppjanar ikel u ħaddied.",
        },
        {
          icon: "Heart",
          title: "Istalla tal-pensjoni",
          body: "Portal għas-sidien, istruzzjonijiet tal-kura individwali, aġenda kondiviża.",
        },
        {
          icon: "Target",
          title: "Istalla ta' taħriġ qbiż",
          body: "Ppjanar kompetizzjonijiet, taħriġ għal kull żiemel, kuntatt mal-klijenti.",
        },
        {
          icon: "FileText",
          title: "Intraprendituri hippika",
          body: "Taħlita ta' lezzjonijiet + pensjoni + klinika + kummerċ — kollox minn sistema waħda.",
        },
      ],
    },
    criteria: {
      title: "X'għandu jissodisfa software tajjeb għall-manège?",
      lead: "App sabiħa ma tfisser xejn jekk il-ħaddiema tiegħek ma jridux jaħdmu biha. Ħames kriterji prattiċi li jagħmlu d-differenza bejn is-suċċess u l-frustrazzjoni.",
      items: [
        {
          icon: "Calendar",
          title: "Ppjanar lezzjonijiet fuq diversi livelli",
          body: "Prinċipjant/avvanzat, dressage/qbiż, koppji żwiemel u aġendi tal-istruttori — kollox viżibbli flimkien.",
        },
        {
          icon: "Users",
          title: "Amministrazzjoni kavalieri",
          body: "Profili, livell, abbonament, karta tal-lezzjonijiet u koppji ta' membri tal-familja għal kavalieri żgħażagħ.",
        },
        {
          icon: "Heart",
          title: "Ġestjoni żwiemel",
          body: "Liema żiemel jintuża kemm-il darba, b'perjodi ta' mistrieħ, inġurja u ċiklu.",
        },
        {
          icon: "CreditCard",
          title: "Fatturazzjoni & abbonamenti",
          body: "Abbonamenti mensili, karti tal-lezzjonijiet, lezzjonijiet individwali u inċasso awtomatiku.",
        },
        {
          icon: "Share2",
          title: "Portal tas-sidien (istalla tal-pensjoni)",
          body: "Is-sidien jaraw żiemlhom fl-app tagħhom stess — aġenda, spejjeż, ħaddied u noti mingħajr ma jċemplu.",
        },
        {
          icon: "Bell",
          title: "Komunikazzjoni & tfakkir",
          body: "Tfakkir awtomatiku tal-lezzjonijiet, notifiki tal-ħlas, annunċji tal-ħaddied — mingħajr apping.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs software oħra tal-manège.",
      lead: "Ħafna għodod tal-manège huma qawwija fl-ippjanar tal-lezzjonijiet jew il-fatturazzjoni, iżda rarament fil-kura tal-żwiemel u l-komunikazzjoni mas-sidien flimkien. Nqabblu b'mod ġust.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Tibda b'xejn / perjodu ta' prova",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Ppjanar lezzjonijiet",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Diversi istruttori",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Amministrazzjoni kavalieri",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ġestjoni żwiemel",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Kura żwiemel (vaċċini/ħaddied)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Karta lezzjonijiet / abbonament",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Ħlasijiet onlajn",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Fatturazzjoni awtomatika",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Portal tas-sidien (pensjoni)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Integrazzjoni ħaddied/veterinarju",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Tfakkir WhatsApp/SMS",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Mobbli (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Ppjanar kompetizzjonijiet",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Adattat għal istalla tal-pensjoni",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Paragun ibbażat fuq karatteristiċi disponibbli pubblikament f'Jannar 2026. Stalmanager huwa qawwi fl-amministrazzjoni, EquiSight jiddistingwi ruħu fil-fluss tal-istalla tal-pensjoni + kura żwiemel + portal tas-sidien.",
    },
    why: {
      title: "Għaliex EquiSight huwa differenti għall-maneġġi u stalli tal-pensjoni.",
      lead: "EquiSight imur lil hinn minn ppjanar lezzjonijiet. Naraw il-manège bħala operazzjoni kompluta: żwiemel, nies, komunikazzjoni u flus — kollox jiddependi minn xulxin.",
      points: [
        {
          icon: "Heart",
          title: "Iż-żiemel fiċ-ċentru, mhux l-aġenda",
          body: "Kull żiemel għandu l-kartella tiegħu. Użu f'lezzjonijiet, saħħa, ħaddied u kompetizzjonijiet f'linja temporali waħda — mhux 3 għodod separati.",
        },
        {
          icon: "Share2",
          title: "Is-sidien isegwu mingħajr ma jċemplu",
          body: "Is-sidien tal-istalla tal-pensjoni għandhom il-veduta tagħhom stess: spejjeż, ppjanar, ritratti u noti — tiffranka 5-10 telefonati fil-ġimgħa.",
        },
        {
          icon: "Bell",
          title: "Komunikazzjoni awtomatika",
          body: "Tfakkir lezzjoni, tfakkir vaċċin, fattura — awtomatikament, permezz ta' app/email/SMS. L-ebda broadcast-WhatsApp aktar.",
        },
      ],
    },
    nicheB: {
      eyebrow: "Għall-istalla tal-pensjoni",
      title: "Dak li istalla tal-pensjoni tikseb minn EquiSight.",
      lead: "L-istalli tal-pensjoni għandhom sfidi uniċi li software normali tal-manège ma jsolvi.",
      cards: [
        {
          t: "Portal tas-sidien",
          d: "Kull sid jara biss iż-żiemel/żwiemel tiegħu, l-aġenda u l-ispejjeż.",
        },
        {
          t: "Istruzzjonijiet tal-kura għal kull żiemel",
          d: "Ikel, tibn, supplimenti, ġestjoni dkaken — viżibbli għall-istalla.",
        },
        {
          t: "Aġenda kondiviża",
          d: "Ħaddied, veterinarju u żjarat tas-sidien f'veduta waħda.",
        },
        {
          t: "Spejjeż tal-konsum għal kull żiemel",
          d: "Friex, ikel, ikel tal-qawwa mgħoddi lil kull sid.",
        },
        {
          t: "Kuntatti ta' emerġenza taż-żiemel",
          d: "Sid + veterinarju + ħaddied dejjem faċilment sabiħ għall-istalla.",
        },
        {
          t: "Ġestjoni btajjel",
          d: "Liema żwiemel sejrin fuq mergħa, mistrieħ jew riabilitazzjoni?",
        },
      ],
    },
    beforeAfter: {
      title: "Minn whiteboard + Excel għal EquiSight.",
      lead: "Konkretu: hekk tinbidel ġimgħa ta' xogħol fil-manège.",
      rows: [
        {
          before: "Whiteboard bl-ippjanar tal-lezzjonijiet",
          after: "Ppjanar live għal kull istrutttur",
        },
        {
          before: "Excel bil-kavalieri + noti tal-lezzjonijiet",
          after: "CRM tal-klijenti bl-istorja tal-lezzjonijiet",
        },
        {
          before: "WhatsApp lis-sidien",
          after: "Portal tas-sidien għaż-żiemel tagħhom",
        },
        {
          before: "Inċasso mensili manwali",
          after: "Fatturazzjoni awtomatika + iDEAL",
        },
        {
          before: "Kura żwiemel fuq bord tal-kaħħala",
          after: "Istruzzjonijiet tal-kura għal kull żiemel, kondiviżi",
        },
        {
          before: "Appuntament verbali mal-ħaddied",
          after: "Ppjanar ħaddied b'konfermi",
        },
      ],
    },
    helper: {
      title: "Liema software tal-manège jaqbel miegħek?",
      lead: "5 domandi biex tara jekk EquiSight huwiex il-pjattaforma t-tajba għall-manège jew l-istalla tal-pensjoni tiegħek.",
      questions: [
        {
          id: "size",
          q: "Kemm żwiemel għandek fin-negozju tiegħek?",
          options: [
            {
              label: "Inqas minn 10",
              score: 1,
            },
            {
              label: "10-30",
              score: 2,
            },
            {
              label: "Aktar minn 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "X'inhi l-attività prinċipali tiegħek?",
          options: [
            {
              label: "L-aktar tagħti lezzjonijiet",
              score: 1,
            },
            {
              label: "Istalla tal-pensjoni (żwiemel f'pensjoni)",
              score: 3,
            },
            {
              label: "Taħlita ta' lezzjonijiet + pensjoni",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "Ma' kemm istruttturi taħdem?",
          options: [
            {
              label: "Jien waħdi",
              score: 1,
            },
            {
              label: "2-3 istruttturi",
              score: 2,
            },
            {
              label: "4 jew aktar",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "Kif torganizza l-fatturazzjoni tiegħek bħalissa?",
          options: [
            {
              label: "Manwalment (Word/Excel)",
              score: 3,
            },
            {
              label: "Programm tal-kontabilità separat",
              score: 2,
            },
            {
              label: "Integrat fl-għodda tal-lezzjonijiet",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "Kif tikkomunika mas-sidien?",
          options: [
            {
              label: "Personalment / WhatsApp",
              score: 3,
            },
            {
              label: "Email + WhatsApp",
              score: 2,
            },
            {
              label: "Portal tas-sidien fl-għodda",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Għodda ħafifa jew Excel tista' tgħodd għal issa — iżda EquiSight tikber miegħek.",
          body: "Għal negozju żgħir tal-lezzjonijiet b'istrutttur wieħed u ftit pensjoni, pakkett elaborat mhux meħtieġ immedjatament. EquiSight jibda b'xejn u jikber mal-manège tiegħek — l-ebda uġigħ ta' migrazzjoni f'xi snin.",
          cta: "Ibda b'xejn",
        },
        mid: {
          title: "EquiSight huwa aġġornament loġiku għall-manège tiegħek.",
          body: "Diversi istruttturi, taħlita ta' lezzjonijiet u pensjoni, jew fatturazzjoni li bħalissa hija separata — EquiSight jagħqad kollox f'fluss tax-xogħol wieħed. B'mod partikolari l-portal tas-sidien jiffranka ħafna komunikazzjoni ad-hoc.",
          cta: "Itlob demo",
        },
        high: {
          title: "EquiSight huwa mibni għall-iskala tiegħek.",
          body: "Istalla tal-pensjoni + lezzjonijiet + diversi istruttturi huwa eżattament fejn EquiSight jiddistingwi ruħu mill-għodod klassici tal-manège. Il-portal tas-sidien u l-integrazzjoni tal-kura żwiemel jiffrankaw sigħat ta' amministrazzjoni u komunikazzjoni kull ġimgħa.",
          cta: "Ppjana demo għall-istalla tiegħek",
        },
      },
    },
    faqTitle: "Mistoqsijiet frekwenti dwar software tal-manège",
    faq: [
      {
        q: "X'inhu l-aqwa software għall-manège?",
        a: "Għall-ippjanar puro tal-lezzjonijiet hemm diversi għażliet tajba. Minn meta jkollok bżonn istalla tal-pensjoni, diversi istruttturi jew traċċar tal-kura żwiemel, EquiSight jsir is-soluzzjoni kompluta — l-ebda ġuggling tal-għodod, kollox f'post wieħed.",
      },
      {
        q: "Nista' nimporta klijenti u lezzjonijiet eżistenti?",
        a: "Iva. Id-data tal-klijenti u l-iskedi tal-lezzjonijiet jistgħu jiġu importati permezz ta' CSV. Ngħinu lill-maneġġi attivi b'migrazzjoni ta' darba waħda sabiex ma jkollokx tidħol 200 kavalier manwalment.",
      },
      {
        q: "Jaħdem ukoll għal istalla tal-pensjoni mingħajr lezzjonijiet?",
        a: "Iva. Il-modalità tal-istalla tal-pensjoni tiddisattiva l-lezzjonijiet u tiffoka fuq il-portal tas-sidien, ikel/kura, ppjanar ħaddied u spejjeż mgħoddija għal kull żiemel.",
      },
      {
        q: "Jistgħu l-kavalieri jirreġistraw u jħallsu huma stess?",
        a: "Iva. Il-kavalieri jistgħu permezz tal-kont tagħhom jaraw liema lezzjonijiet huma miftuħa, jirreġistraw, iħallsu t-tariffa tal-lezzjonijiet b'iDEAL u jixtru karti tal-lezzjonijiet.",
      },
      {
        q: "X'inhu s-sitwazzjoni dwar il-privatezza tad-data taż-żwiemel u s-sidien?",
        a: "Kull persuna għandha rwol (sid, kavalier, istrutttur, impjegat). Skont ir-rwol tiegħek tara biss dak li għandek bżonn. Is-sidien jaraw biss iż-żiemel tagħhom, il-kavalieri jaraw biss il-lezzjonijiet tagħhom stess.",
      },
      {
        q: "Jista' EquiSight jikkollega mas-software tal-kontabilità tiegħi?",
        a: "Iva, il-konnessjonijiet ma' Exact, Moneybird u e-Boekhouden huma disponibbli. Il-fatturi jgħaddu awtomatikament fil-kontabilità tiegħek.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "App tat-trainer taż-żwiemel: tqabbil u għajnuna fl-għażla għall-kouċis 2026",
      description: "Qabbel apps tat-trainer għaż-żiemel u r-reġġied: log tat-taħriġ, vidjo, miri, analiżi tal-protokoll u ġestjoni tal-klijenti. Sib l-għodda t-tajba għall-kouċis.",
      keywords: [
        "app tat-trainer taż-żwiemel",
        "app tal-istruttур",
        "app tat-taħriġ taż-żiemel",
        "app tal-kowċing tar-reġġied",
        "djarju tat-taħriġ taż-żiemel",
        "analiżi tal-protokoll tad-dressage",
        "softwer tat-trainer taż-żwiemel",
      ],
    },
    hero: {
      eyebrow: "Għajnuna fl-għażla · softwer tat-trainer",
      breadcrumbLabel: "App tat-trainer",
      title: "App tat-trainer taż-żwiemel: għajnuna kompleta fl-għażla għall-istrутturi u l-kouċis.",
      intro: "Trainer jew istruttур iżomm bilanċ bejn kombinazzjonijiet, lezzjonijiet, vidjows, miri u kompetizzjonijiet. Qabbel l-aħjar apps tat-trainer għan-nies taż-żwiemel u agħżel il-pjattaforma li ser tibqa' tikber miegħek sal-2026.",
      pills: [
        {
          icon: "Target",
          label: "Miri u ppjanar",
        },
        {
          icon: "Video",
          label: "Analiżi bil-vidjo",
        },
        {
          icon: "TrendingUp",
          label: "Progress",
        },
        {
          icon: "Users",
          label: "Klijenti/kombinazzjonijiet",
        },
      ],
      ctas: [
        {
          label: "Ibda b'xejn bħala trainer",
          href: "#start",
          primary: true,
        },
        {
          label: "Għall-tabella tal-tqabbil",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Għaliex il-kowċing permezz ta' WhatsApp jfixkel lit-trainers.",
      lead: "Il-biċċa l-kbira tat-trainers jaħdmu b'għodod separati: WhatsApp għall-komunikazzjoni, ktieb tan-noti għal-lezzjonijiet, YouTube jew WeTransfer għall-vidjows u Excel għar-riżultati tal-kompetizzjonijiet. Ma' 5 reġġieda jaħdem. Ma' 20 reġġied, l-informazzjoni tintilef, tinsa l-miri u titlef il-kontroll fuq il-progress individwali.",
      items: [
        "Fejn insibu l-mira ta' Anouk għal din is-staġun?",
        "Liema vidjo bgħatt lil Bram ix-xahar li għadda?",
        "Lara rat l-analiżi tal-protokoll tal-aħħar kompetizzjoni tagħha?",
        "Liema kombinazzjoni titħarreġ kemm-il darba fil-ġimgħa?",
        "Is-sid ta' Stardust qara l-istruzzjonijiet tat-taħriġ tiegħi?",
        "Meta kont l-aħħar darba li tajt feedback fuq impulsi li jivarjaw?",
      ],
    },
    what: {
      title: "X'inhi app tat-trainer għaż-żiemel u r-reġġied?",
      lead: "App tat-trainer tgħaqqad CRM tal-kowċing (kombinazzjonijiet, lezzjonijiet, miri), log tat-taħriġ għal kull żiemel, feedback bil-vidjo, ippjanar tal-kompetizzjonijiet u analiżi tal-protokoll. Le aktar WhatsApp/YouTube/Excel separati, iżda pjattaforma waħda fejn trainer u reġġied jaħdmu flimkien.",
      targetGroupsTitle: "Għal liema tip ta' trainer huwa dan?",
      targetGroups: [
        {
          icon: "Target",
          title: "Istruttур tad-dressage",
          body: "Skennja protokoll, waħħal il-kummenti tal-imħallfin mal-miri tat-taħriġ, ara l-progress.",
        },
        {
          icon: "Activity",
          title: "Trainer tal-ġumpjar",
          body: "Ippjanar tal-kors, feedback fuq ir-rawnd, ġestjoni tal-għoli għal kull żiemel.",
        },
        {
          icon: "Award",
          title: "Kouċ tal-eventing",
          body: "Tliet dixxiplini, tliet pjanijiet - kollox viżibbli fl-istess ħin.",
        },
        {
          icon: "TrendingUp",
          title: "Kouċ tal-prestazzjoni (sport)",
          body: "Traċċar tal-EPI, kompetizzjonijiet, miri — għal atleti ta' livell għoli u t-timijiet tagħhom.",
        },
        {
          icon: "Users",
          title: "Istruttур tal-manège",
          body: "Lezzjonijiet tal-grupp + kowċing individwali f'app waħda.",
        },
        {
          icon: "Heart",
          title: "Kouċ rikreattiv",
          body: "Terapija ekwestri, dħul fil-qasam, sidien b'żiemel wieħed.",
        },
      ],
    },
    criteria: {
      title: "X'għandha tissodisfa app tajba tat-trainer?",
      lead: "It-taħriġ huwa xogħol uman, iżda l-għodda t-tajba tagħmlek 30-50% aktar effiċjenti u tgħin lir-reġġieda jitjiebu anki bejn lezzjoni u oħra.",
      items: [
        {
          icon: "Users",
          title: "Ġestjoni tal-kombinazzjonijiet",
          body: "Żiemel + reġġied bħala unità waħda, bil-livell, il-miri, il-progress u l-istorja.",
        },
        {
          icon: "ClipboardList",
          title: "Noti tal-lezzjonijiet u miri",
          body: "Nota għal kull lezzjoni b'punti ta' fokus, marbuta mal-miri fit-tul.",
        },
        {
          icon: "Video",
          title: "Feedback bil-vidjo",
          body: "Uplowdja vidjo, tagja mumentijiet, żid feedback bil-kelma jew bil-kitba.",
        },
        {
          icon: "Target",
          title: "Analiżi tal-kompetizzjoni u l-protokoll",
          body: "Skennja protokolli (KNHS/FEI), ara l-iskors għal kull sezzjoni, kummenti tal-imħallfin u tendenzi.",
        },
        {
          icon: "Calendar",
          title: "Ppjanar u karti tal-lezzjonijiet",
          body: "Aġenda, ħlasijiet, abbonamenti u tfakkira awtomatika.",
        },
        {
          icon: "Share2",
          title: "Komunikazzjoni mar-reġġied",
          body: "Ir-reġġied jara l-paġna tiegħu stess bil-lezzjonijiet, vidjows, miri u feedback.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs apps oħra tat-trainer.",
      lead: "Xi għodod tat-trainer jiffukaw fuq is-sostituzzjoni ta' WhatsApp, oħrajn fuq l-analiżi tal-protokoll. EquiSight jgħaqqad it-tnejn ma' dossier veru taż-żiemel — biex ir-reġġied jitjib anki bejn lezzjoni u oħra.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Ibda b'xejn",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Ġestjoni tal-kombinazzjonijiet",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Noti tal-lezzjonijiet u feedback",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Miri fit-tul",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Uplowdjar vidjo + feedback",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Skenji ta' protokoll KNHS/FEI",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (Indiċi tal-Prestazzjoni)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Kalendarju tal-kompetizzjonijiet",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Portal tar-reġġied",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Karta tal-lezzjonijiet / abbonament",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Ħlasijiet onlajn",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Dossier integrat taż-żiemel",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Farrier/veterinarju viżibbli",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Għall-istruttур U r-reġġied",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Żwiemel multipli għal kull reġġied",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Tqabbil ibbażat fuq karatteristiċi disponibbli pubblikament f'Jannar 2026. EquiSight huwa uniku fl-analiżi tal-protokoll + EPI u jgħaqqad dan mal-ġestjoni ġenerali taż-żwiemel.",
    },
    why: {
      title: "Għaliex EquiSight joffri esperjenza differenti ta' trainer.",
      lead: "Il-biċċa l-kbira tal-għodod tat-trainer jieqfu fejn tieqaf il-lezzjoni. EquiSight ikompli — fid-dossier taż-żiemel, fl-analiżi tal-kompetizzjoni, fil-kollaborazzjoni mal-veterinarju u s-sid.",
      points: [
        {
          icon: "TrendingUp",
          title: "Skenji tal-protokoll → mira tat-taħriġ",
          body: "Skennja protokoll KNHS u ara immedjatament liema sezzjonijiet jeħtieġu attenzjoni. Il-miri joħorġu awtomatikament.",
        },
        {
          icon: "Sparkles",
          title: "EquiCoach isaħħaħ il-ħarsa tiegħek",
          body: "Data minn diversi lezzjonijiet, kompetizzjonijiet u protokolli turi mudelli li ma tistax żżomm f'rasek.",
        },
        {
          icon: "Share2",
          title: "Integrat maż-żiemel",
          body: "It-trainer jara l-vaċċini, il-farrier u l-istorja tal-korrimenti taż-żiemel — ma tippjanax taħriġ waqt il-fejqan.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Għad-dressage u l-ġumpjar",
      title: "X'fih dossier tal-kowċing f'EquiSight.",
      lead: "Għal kull kombinazzjoni tirċievi stream tal-kowċing li żżomm kollox flimkien — le aktar affarijiet jintilfu fil-WhatsApp.",
      items: [
        "Noti tal-lezzjonijiet b'punti ta' fokus għal kull sessjoni",
        "Miri fit-tul + marki importanti",
        "Uplowdjar ta' vidjo bi kummenti fuq il-kodici taż-żmien",
        "Skenji ta' protokoll KNHS/FEI bl-iskors",
        "Kummenti tal-imħallfin marbuta mat-taħriġ",
        "Riżultati tal-kompetizzjonijiet u tendenzi tal-EPI",
        "Kuntatt mal-klijent u storja tal-lezzjonijiet",
        "Karta tal-lezzjonijiet / abbonament / fatturi",
        "Grafiku tal-progress għal kull dixxiplina",
        "Aċċess kondiviż mas-sid taż-żiemel",
      ],
      ctaLabel: "Ara l-modulu tat-trainer",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "Minn WhatsApp + YouTube għal EquiSight Trainer.",
      lead: "Konkretatment: hekk tinbidel il-flusso tal-kowċing tiegħek.",
      rows: [
        {
          before: "WhatsApp b'links tal-vidjo separati",
          after: "Vidjo b'feedback fuq il-kodici taż-żmien fid-dossier",
        },
        {
          before: "Ktieb tan-noti għal kull reġġied",
          after: "Log tal-kowċing bil-miri + storja",
        },
        {
          before: "Excel bl-iskors tal-kompetizzjonijiet",
          after: "Grafiku EPI + analiżi tal-protokoll",
        },
        {
          before: "Miri verbali",
          after: "Marki importanti b'indikatur tal-progress",
        },
        {
          before: "Għodda separata tal-fatturazzjoni",
          after: "Lezzjonijiet + iDEAL + abbonament fl-app",
        },
        {
          before: "Email lis-sid fuq il-progress",
          after: "Is-sid isegwi fil-veduta tiegħu stess",
        },
      ],
    },
    helper: {
      title: "Liema app tat-trainer taqbel miegħek?",
      lead: "5 mistoqsijiet biex tara jekk għodda speċjalizzata tal-kowċing iżżid valur għall-prattika tiegħek.",
      questions: [
        {
          id: "clients",
          q: "Kemm kombinazzjonijiet attivi tikkouċja?",
          options: [
            {
              label: "Inqas minn 5",
              score: 1,
            },
            {
              label: "5-15",
              score: 2,
            },
            {
              label: "Aktar minn 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "X'inhi d-dixxiplina prinċipali tiegħek?",
          options: [
            {
              label: "Dressage",
              score: 3,
            },
            {
              label: "Ġumpjar",
              score: 2,
            },
            {
              label: "Rikreattiv / divers",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "Tuża l-vidjo fil-kowċing?",
          options: [
            {
              label: "Rarament",
              score: 0,
            },
            {
              label: "Xi kultant (manwalment)",
              score: 2,
            },
            {
              label: "Spiss — b'mod strutturali",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "Tikkouċja reġġieda tal-kompetizzjoni?",
          options: [
            {
              label: "Le, rikreattiv",
              score: 0,
            },
            {
              label: "Xi kultant kompetizzjonijiet",
              score: 2,
            },
            {
              label: "Ħafna — karti tal-bidu ċentrali",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Trid tkejjel il-kowċing tiegħek?",
          options: [
            {
              label: "Le, l-intuizzjoni biżżejjed",
              score: 0,
            },
            {
              label: "Iva, iżda m'għandix żmien",
              score: 2,
            },
            {
              label: "Iva — kowċing ibbażat fuq data",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Għodda sempliċi jew saħansitra WhatsApp hija biżżejjed — għalissa.",
          body: "Għal inqas minn 5 reġġieda mingħajr ħafna vidjo jew kompetizzjonijiet, app tal-kowċing hija żejda. EquiSight jibda b'xejn, għalhekk tista' tippruvah meta l-prattika tiegħek tikber.",
          cta: "Ibda b'xejn",
        },
        mid: {
          title: "EquiSight Trainer jagħmlek aktar effiċjenti b'mod strutturali.",
          body: "Ma' 5-15 kombinazzjonijiet titlef sigħat kull xahar fuq WhatsApp u vidjows separati. EquiSight jgħaqqad kollox, jiskennja l-protokolli awtomatikament u jiżgura li r-reġġieda jistgħu dejjem jaraw il-feedback tagħhom.",
          cta: "Ipprova l-modulu Trainer",
        },
        high: {
          title: "EquiSight huwa maħluq għall-iskala tal-kowċing tiegħek.",
          body: "Ħafna reġġieda, vidjo, kompetizzjonijiet u kowċing ibbażat fuq data: dan huwa eżattament fejn EquiSight jidher distint. EPI + skenji tal-protokoll + dossier taż-żiemel jagħtuk vantaġġ li l-kompetituri ma għandhomx.",
          cta: "Ppjana demo għall-prattika tal-kowċing tiegħek",
        },
      },
    },
    faqTitle: "Mistoqsijiet frekwenti dwar apps tat-trainer",
    faq: [
      {
        q: "X'inhi l-aħjar app tat-trainer għaż-żiemel u r-reġġied?",
        a: "Għall-komunikazzjoni pura, ħafna għodod huma biżżejjed (anki WhatsApp). Għall-miri, analiżi bil-vidjo, skenji tal-protokoll, traċċar tal-kompetizzjonijiet u ġestjoni tal-klijenti f'għodda waħda, EquiSight huwa l-aktar soluzzjoni kompleta — speċjalment għax isegwi wkoll iż-żiemel innifsu, mhux biss il-kombinazzjoni.",
      },
      {
        q: "Jista' EquiSight jaqra l-protokolli tal-kompetizzjonijiet awtomatikament?",
        a: "Iva. Uplowdja protokoll KNHS jew FEI u EquiSight jestratti l-iskors għal kull sezzjoni, il-kummenti tal-imħallfin u jwaħħalhom mal-kombinazzjoni. Tara t-tendenzi fuq diversi kompetizzjonijiet.",
      },
      {
        q: "X'inhu l-EPI (Equestrian Performance Index)?",
        a: "EPI huwa skors ta' EquiSight li jikkonverti diversi riżultati tal-kompetizzjonijiet f'indiċi komparabbli tal-prestazzjoni. B'hekk tara progress reali tul klassijiet u mħallfin differenti.",
      },
      {
        q: "Jistgħu r-reġġieda jibbukkjaw u jħallsu l-lezzjonijiet tagħhom stess?",
        a: "Iva. Ir-reġġieda jidħlu, jaraw il-ħinijiet tal-lezzjonijiet disponibbli, jixtru karti tal-lezzjonijiet u jħallsu permezz ta' iDEAL. Int tiddeċiedi x'toffri u x'le.",
      },
      {
        q: "Jaħdem ukoll għal istruttур li jaħdem madwar il-manège?",
        a: "Iva. Tista' taħdem bħala trainer freelance bil-klijenti tiegħek stess mingħajr ma torbot kont tal-manège. Il-klijenti jħallsuk direttament.",
      },
      {
        q: "Nista' nimporta vidjows u noti eżistenti?",
        a: "Il-vidjows tista' tuplowdjaħom għal kull kombinazzjoni jew permezz ta' għodda ta' uplowdjar bl-ingrossa. Importar tan-noti permezz ta' CSV. Ngħinu lit-trainers attivi b'migrazzjoni ta' darba.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "Gwidi & għodod tal-għażla għal softwer ta' ġestjoni tal-ħżieb | EquiSight",
      description: "Il-gwidi kollha ta' EquiSight f'post wieħed: ġestjoni tal-ħżieb, trobbija, manège u tqabbil ta' softwer għall-inkwilitur flimkien ma' għodod tal-għażla għall-2026.",
      keywords: [
        "gwidi softwer tal-ħżieb",
        "għajnuna fl-għażla ta' ġestjoni tal-ħżieb",
        "tqabbil ta' softwer tat-trobbija",
        "gwida softwer manège",
        "tqabbil ta' app tal-inkwilitur",
      ],
    },
    hub: {
      eyebrow: "Hub · Gwidi",
      breadcrumbLabel: "Gwidi",
      title: "Erba' gwidi kompluti biex tagħżel is-softwer tal-ħżieb it-tajjeb.",
      intro: "Għal kull grupp ta' utenti hemm għajnuna dettaljata fl-għażla: tabelli ta' tqabbil, kriterji, eżempji u kwiz interattiv. Ikklikkja fuq il-gwida li taqbel mas-sitwazzjoni tiegħek, jew espjora l-ewwel l-artikoli fil-fond taħt kull cluster.",
      stats: {
        guides: "4 għodod tal-għażla",
        articles: "15-il artikolu fil-fond",
        fair: "Tqabbil Onest",
      },
      readMoreCta: "Aqra l-gwida kompluta",
      relatedHeading: "Artikoli fil-fond",
      articlesCountSingular: "{{count}} artikolu fil-fond",
      articlesCountPlural: "{{count}} artikoli fil-fond",
      articlesCountAria: "Numru ta' artikoli tal-cluster",
      lastUpdatedPrefix: "Aġġornat",
      lastUpdatedAria: "Data tal-aħħar aġġornament ta' dan il-cluster",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Għajnuna fl-għażla ta' app għall-ġestjoni tal-ħżieb",
        blurb: "Qabbel l-apps l-aktar magħrufa għall-ġestjoni tal-ħżieb u skopri liema taqbel mal-proprjetarju, l-istalla jew it-trobbija. Jinkludi tabella ta' tqabbil onesta u għajnuna fl-għażla b'5 mistoqsijiet.",
        audience: "Għal sidien, sidien ta' stallieri u dawk kollha li jfittxu ħarsa ġenerali.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Tqabbil ta' softwer tat-trobbija",
        blurb: "Miċ-ċiklu tal-ferħa sal-iżvilupp tas-swarraf: ara liema softwer tat-trobbija jaħdem tassew għan-numru ta' ferħiet, il-metodu tat-trobbija u r-rekwiżiti tal-ktieb taż-żwiemel tiegħek.",
        audience: "Għal (dilettanti) trobbija, stallara u sidien tal-fħula.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Għajnuna fl-għażla ta' softwer tal-manège",
        blurb: "Ippjanar tal-lezzjonijiet, amministrazzjoni tas-sewwieqa, portal tas-sidien u fatturazzjoni — f'għodda waħda. Qabbel l-għażliet għall-manèges u stallieri tal-pensjoni fl-2026.",
        audience: "Għall-manèges, stallieri tal-pensjoni u impriżi ekwestri.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Għajnuna fl-għażla ta' app għall-inkwilitur",
        blurb: "Coaching-CRM, feedback bil-vidjo, skennjar tal-protokoll KNHS u miri għal kull kombinazzjoni. Liema app tal-inkwilitur taqbel mal-prattika ta' coaching tiegħek?",
        audience: "Għal struzzuri, inkwiliri u coaches.",
      },
    ],
    closing: {
      eyebrow: "Għaliex dawn il-gwidi",
      title: "Tqabbil onest, mhux biss prezzijiet.",
      body1: "Ħafna \"paġni ta' tqabbil\" huma reklamar moħbi. Il-gwidi tagħna jqiegħdu l-funzjonijiet, il-grupp ta' utenti u l-kompetituri maġenb xulxin bħalma tagħmel sors ta' għarfien indipendenti. EquiSight tidher b'mod naturali bħala soluzzjoni kompluta, iżda taqra wkoll b'mod onest fejn apps oħra huma aktar qawwija.",
      body2: "L-artikoli fil-fond taħt kull gwida jwieġbu l-mistoqsijiet konkreti li jirriżultaw mill-għażla: \"Meta l-ewwel ekoġrafija wara l-inseminazzjoni\", \"Kif nawtomatizza l-fatturazzjoni tal-manège\", \"Kif nanalizza protokoll ta' kompetizzjoni\". L-ebda fluff ta' marketing, iżda prattika reali.",
    },
    hubName: "EquiSight Gwidi",
  },
  ui: {
    sectionEyebrows: {
      pains: "Għaliex dan jagħmel uġigħ",
      basics: "Il-Bażi",
      criteria: "X'jagħmilha tajba?",
      comparison: "Paragun onest",
      why: "Id-differenza",
      beforeAfter: "Minn frammentazzjoni għal ħarsa ġenerali",
      helper: "5 mistoqsijiet",
    },
    table: {
      feature: "Funzjoni",
      today: "Illum",
      withEquisight: "Ma' EquiSight",
    },
    helper: {
      questionLabel: "Mistoqsija {{current}} minn {{total}}",
      answerPrompt: "Wieġeb il-{{count}} mistoqsija li fadal biex tara rakkomandazzjoni.",
      answerPromptPlural: "Wieġeb il-{{count}} mistoqsijiet li fadal biex tara rakkomandazzjoni.",
      resultEyebrow: "Ir-riżultat tiegħek",
    },
    targetGroupsFallback: "Għal min hu maħsub dan?",
    faqTitleFallback: "Mistoqsijiet frekwenti",
  },
};

export default CORNERSTONES;
